import { render, staticRenderFns } from "./DeliveryTrackingLink.vue?vue&type=template&id=3c2853b5&"
import script from "./DeliveryTrackingLink.vue?vue&type=script&lang=ts&"
export * from "./DeliveryTrackingLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports